<app-vvr-icon [full]="false" [dark]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Inspectielijst {{checklist()?.id ? 'aanpassen' : 'aanmaken'}}</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/{{Routenames.checklists}}">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    @if (form()) {
        <div class="row justify-content-center mb-3">
            <div class="col-12 col-lg-9">
                <div [formGroup]="form()">
                    <div class="pt-3 pb-2">
                        <h4 class="h4 condensed">Algemeen</h4>
                    </div>
                    <mat-form-field class="w-100">
                        <input
                            [formControl]="form().controls.name" matInput
                            placeholder="Naam"
                            type="text">
                        <mat-error>Dit veld is verplicht</mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <input
                            [formControl]="form().controls.number"
                            matInput
                            placeholder="Documentnummer"
                            type="text">
                        <mat-error>Dit veld is verplicht</mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <input
                            [formControl]="form().controls.managed_by"
                            matInput
                            placeholder="Beheert door"
                            type="text">
                        <mat-error>Dit veld is verplicht</mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <input
                            [formControl]="form().controls.version"
                            matInput
                            placeholder="Versie"
                            type="text">
                        <mat-error>Dit veld is verplicht</mat-error>
                    </mat-form-field>
                    <div class="pt-3 pb-2">
                        <h4 class="h4 condensed">Vragen</h4>
                    </div>
                    @if (!form().value.questions?.length) {
                        <div class="text-red text-center">
                            <i>Voeg minimaal 1 groep toe</i>
                        </div>
                    }
                    <div class="questions"
                         cdkDropList
                         [cdkDropListData]="form().controls.questions.controls"
                         (cdkDropListDropped)="drop($event)">
                        @for (question of form().controls.questions.controls; track question; let i = $index) {
                            <div
                                [cdkDragData]="question"
                                cdkDrag>
                                <div class="question">
                                    <div cdkDragHandle class="number">{{question.value.number}}</div>
                                    <mat-form-field class="w-100" style="font-weight: bold">
                                        <textarea (keyup.control.enter)="addQuestion($event, form().controls.questions, null, i)" [formControl]="question.controls.question"
                                                  cdkTextareaAutosize
                                                  id="c{{i}}"
                                                  matInput
                                                  placeholder="Titel"
                                                  type="text">
                                        </textarea>
                                    </mat-form-field>
                                    <button
                                        (click)="removeQuestion(form().controls.questions,i)"
                                        color="primary"
                                        mat-icon-button
                                        tabindex="-1">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                                @if (!question.value.sub_items?.length) {
                                    <div class="text-center text-red">
                                        <i>Voeg minimaal 1 vraag toe</i>
                                    </div>
                                }
                                <div
                                    (cdkDropListDropped)="drop($event)"
                                    [cdkDropListData]="question.controls.sub_items.controls"
                                    cdkDropList
                                    class="questions">
                                    @for (subQuestion of question.controls.sub_items.controls; track subQuestion; let ii = $index) {
                                        <div
                                            (cdkDragDropped)="tiny.reinit()"
                                            [cdkDragData]="subQuestion"
                                            cdkDrag
                                            class="ps-3">
                                            <div *cdkDragPreview class="question">
                                                <div cdkDragHandle class="number">{{subQuestion.value.number}}</div>
                                                <div [innerHTML]="subQuestion.value.question | safeHtml" class="w-100">
                                                </div>
                                            </div>
                                            <div class="question">
                                                <div cdkDragHandle class="number">{{subQuestion.value.number}}</div>
                                                <simple-tiny
                                                    #tiny
                                                    [content]="subQuestion.controls.question"
                                                    [fullscreen]="false"
                                                    [menubar]="false"
                                                    [minHeight]="150"
                                                    [resize]="true"
                                                    class="w-100"
                                                    elementId="{{i}}{{ii}}"
                                                    ngDefaultControl
                                                    propertyName="value">
                                                </simple-tiny>
                                                <button
                                                    (click)="removeQuestion(question.controls.sub_items,ii)"
                                                    color="primary"
                                                    mat-icon-button
                                                    tabindex="-1">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    }
                                    <button (click)="addQuestion($event, question.controls.sub_items, question)" class="w-100"
                                            mat-button>
                                        Vraag {{question.value.number.toUpperCase()}}{{(question.value.sub_items.length + 1)}} toevoegen
                                    </button>
                                </div>
                            </div>
                        }
                        <button
                            (click)="addQuestion($event, form().controls.questions)"
                            class="w-100"
                            mat-button>
                            Groep {{form().value?.questions?.length ? getNextLetter(form().value.questions[form().value.questions.length - 1].number.toUpperCase()) : 'A'}}
                            toevoegen
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-9 col-12 mb-3">
                <div class="d-flex">
                    <button mat-button routerLink="/{{Routenames.checklists}}">Terug</button>
                    <div class="spacer"></div>
                    <button mat-raised-button color="primary" (click)="save()" id="btn-save">
                        Opslaan
                    </button>
                </div>
            </div>
        </div>
    }
</div>
